// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__6v7J7","brand":"Navbar_brand__BCu3v","brandHidden":"Navbar_brandHidden__KF1An"};